import sinImagen from '../../extras/image/sinImagen.png';
import { BsCloudCheck, BsTrash } from 'react-icons/bs';
import { AiOutlinePrinter } from 'react-icons/ai';
import { BotonesTabla } from './productosComponents';
import { baseURL } from '../../extras/Axios';
export const customStyles = {
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
    style: {
      minHeight: '30px', // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: '4px', // override the cell padding for head cells
      paddingRight: '4px',
      backgroundColor: '#a6c6c1',
    },
  },
  cells: {
    style: {
      paddingLeft: '4px', // override the cell padding for data cells
      paddingRight: '4px',
    },
  },
};
export const columnsModal = [
  {
    name: 'Descripcion',
    selector: row => row.descripcion,
    minWidth: '200px',
    wrap: true,
    sortable: true,
  },
  {
    name: 'Talle',
    selector: row => row.talle,
    maxWidth: '90px',
    sortable: true,
  },
  {
    name: 'Precio ',
    selector: row => row.precio,
    maxWidth: '90px',
    sortable: true,
  },
  {
    name: 'Ganancia',
    selector: row => row.ganancia,
    maxWidth: '90px',
    sortable: true,
  },
  {
    name: 'Condición Venta',
    selector: row => row.condicionVenta,
    maxWidth: '90px',
    sortable: true,
  },
  {
    name: 'Estado',
    selector: row => row.estado,
    maxWidth: '120px',
    sortable: true,
  },
];



const parseDate = (dateString) => {
  if (!dateString) return new Date(0);
  
  // Try parsing as ISO string first
  const isoDate = new Date(dateString);
  if (!isNaN(isoDate.getTime())) return isoDate;
  
  // Try parsing as DD/MM/YYYY
  const parts = dateString.split('/');
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
  }
  
  // If all parsing fails, return epoch
  return new Date(0);
};

const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const columns = (deleteAndInform, imprimirCodigo, omitDate, omitCodigo) => [
  {
    name: 'Fecha',
    selector: (row) => {
      const date = parseDate(row.fecha);
      return formatDate(date);
    },
    sortable: true,
    sortFunction: (rowA, rowB) => {
      const dateA = parseDate(rowA.fecha);
      const dateB = parseDate(rowB.fecha);
      
      // Handle invalid dates
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;
      
      return dateA.getTime() - dateB.getTime();
    },
    omit: omitDate ? omitDate : false,
    minWidth: '90px',
  },
  {
    name: 'Codigo',
    sortable: true,
    omit: omitCodigo ? omitCodigo : false,
    sortFunction: (rowA, rowB) => {
      if (parseInt(rowA.UserId) > parseInt(rowB.UserId)) return 1;
      if (parseInt(rowA.UserId) < parseInt(rowB.UserId)) return -1;
      if (parseInt(rowA.codigoProducto) > parseInt(rowB.codigoProducto)) return 1;
      if (parseInt(rowA.codigoProducto) < parseInt(rowB.codigoProducto)) return -1;

      return 0;

    },
    selector: (row) => {
      return `${row.UserId}.${row.codigoProducto}`;
    },
  },
  {
    name: 'Descripcion',
    selector: row => row.descripcion,
    minWidth: '200px',
    wrap: true,
    sortable: true,
  },
  {
    name: 'Talle',
    selector: row => row.talle,
    wrap: true,
    sortable: true,
  },
  {
    name: 'Precio',
    selector: (row) => `$${parseFloat(row.precio).toFixed(2)}`,
    sortFunction: (rowA, rowB) => {
      if (parseFloat(rowA.precio) > parseFloat(rowB.precio)) return 1;
      if (parseFloat(rowA.precio) < parseFloat(rowB.precio)) return -1;

      return 0;

    },
    sortable: true,
  },
  {
    name: 'Ganancia',
    selector: (row) => {
      if (row.quitarGanancia) return `$${parseFloat(row.precio).toFixed(2)}`
      const result = parseFloat(row.ganancia);
      if (isNaN(result)) return 'Sin selecionar';
      return `$${result.toFixed(2)}`;
    },
    sortFunction: (rowA, rowB) => {
      const valueA = parseFloat(rowA.quitarGanancia ? rowA.precio : rowA.ganancia);
      const valueB = parseFloat(rowB.quitarGanancia ? rowB.precio : rowB.ganancia);

      if (valueA > valueB) return 1;
      if (valueA < valueB) return -1;

      return 0;

    },
    sortable: true,
  },
  {
    name: 'Estado',
    selector: row => row.estado,
    sortable: true,
  },
  {
    name: 'Marca',
    selector: row => row.marca,
    sortable: true,
  },
  {
    name: 'Temporada',
    selector: row => row.temporada,
    sortable: true,
  },
  {
    name: 'Foto',
    maxWidth: '50px',
    selector: (row) => {
      const url = `${baseURL}images/`;
      let preview = sinImagen;
      if (row.imagePath && row.imagePath !== '') {
        preview = `${url}${row.imagePath}`;
      }
      return (
        <img height='auto' width='56px' alt={row.descripcion} src={preview} onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = sinImagen;
        }} />
      );
    },
  },
  {
    name: 'Acciones',
    button: true,
    selector: (row) => {
      return (
        <BotonesTabla>
          {
          row.tiendaNubeUrl && 
          <a rel="noreferrer noopener" target='_blank' href={row.tiendaNubeUrl}>
            <BsCloudCheck />
          </a>
          }
          <BsTrash
            onClick={() => {
              if (
                window.confirm(`Seguro que desea eliminar ${row.descripcion} `)
              ) {
                deleteAndInform(row._id);
              }
            }}
            size='1rem'
            title='Borrar'
            cursor='pointer'
          />
          <AiOutlinePrinter
            onClick={() => {
              imprimirCodigo(row);
            }}
            size='1rem'
            title='Imprimir codigo de barras'
            cursor='pointer'
          />
        </BotonesTabla>
      );
    },
  },
];
export const opcionesdepagina = {
  rowsPerPageText: 'Filas por pagina',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
};
